const genericContactNames = new Set(['contato', 'contact', 'contacto'])

function digits(value: unknown) {
  return String(value || '').replace(/\D/g, '')
}

export function normalizedVoiceContactName(name: unknown, phone: unknown) {
  const value = String(name || '')
    .trim()
    .replace(/\s+/g, ' ')
  if (!value || genericContactNames.has(value.toLocaleLowerCase())) return ''
  if (digits(value) && digits(value) === digits(phone)) return ''
  return /\p{L}/u.test(value) ? value : ''
}
